"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _reactComponents = require("@cimpress/react-components");

var _react = _interopRequireWildcard(require("react"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _reactIntl = require("react-intl");

var _services = require("../services");

var _SkuCard = _interopRequireDefault(require("../SkuCard/SkuCard"));

var _CooldownTextField = _interopRequireDefault(require("./CooldownTextField"));

var _SkuUploadModal = _interopRequireDefault(require("../SelectedSkuBin/SkuUploadModal"));

var _SkuCardVirtualizedList = _interopRequireDefault(require("../SkuCard/SkuCardVirtualizedList"));

var _skuSelectorMessages = require("../skuSelectorMessages");

var PAGE_SIZE = 50;

var SkuSearch =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SkuSearch, _PureComponent);

  function SkuSearch() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SkuSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SkuSearch)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      totalCount: 0,
      currentPage: 0,
      query: '',
      skuSearchResult: [],
      filteredSkus: [],
      querying: false,
      error: null,
      fetchId: null,
      addSkusModalOpened: false
    };

    _this.onSubmit = function (e) {
      e.preventDefault();
    };

    _this.onSearch = function (q) {
      _this.onQuery(q, 1);
    };

    _this.onQuery = function (q, page) {
      var _this$props = _this.props,
          sellerFulfillerId = _this$props.sellerFulfillerId,
          onGetAccessToken = _this$props.onGetAccessToken,
          marketable = _this$props.marketable,
          onFetch = _this$props.onFetch,
          formatMessage = _this$props.intl.formatMessage;
      var id = Date.now();

      _this.setState({
        querying: true,
        currentPage: page,
        fetchId: id
      },
      /*#__PURE__*/
      (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var response, count, skuMap, error, filteredSkus;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _services.searchSku)(q, [sellerFulfillerId], PAGE_SIZE, page, onGetAccessToken, marketable, null, formatMessage).catch(function (e) {
                  return {
                    count: 0,
                    skuMap: {},
                    error: e ? e.message : formatMessage(_skuSelectorMessages.skuSearchMessages.defaultErrorMessage)
                  };
                });

              case 2:
                response = _context.sent;
                count = response.count;
                skuMap = response.skuMap, error = response.error;
                filteredSkus = [];

                if (!(!error && onFetch)) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 7;
                _context.next = 10;
                return Promise.resolve(onFetch(skuMap));

              case 10:
                skuMap = _context.sent;
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](7);
                error = _context.t0.message ? _context.t0.message : formatMessage(_skuSelectorMessages.skuSearchMessages.defaultErrorMessage);
                skuMap = null;

              case 17:
                if (_this.state.fetchId === id) {
                  _this.setState({
                    totalCount: count,
                    skuSearchResult: skuMap,
                    filteredSkus: filteredSkus,
                    querying: false,
                    error: error
                  });
                }

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      })));
    };

    _this.onSearchValueChange = function (v) {
      _this.setState({
        query: v.target ? v.target.value : v
      });
    };

    _this.closeAddSkusModal = function () {
      _this.setState({
        addSkusModalOpened: false
      });
    };

    _this.openAddSkusModal = function () {
      _this.setState({
        addSkusModalOpened: true
      });
    };

    _this.skuCardRenderer = function (skuInfo) {
      var _this$props2 = _this.props,
          onAddAction = _this$props2.onAddAction,
          disabled = _this$props2.disabled,
          excludingSkus = _this$props2.excludingSkus,
          skuCardCustomRenderFn = _this$props2.skuCardCustomRenderFn,
          formatMessage = _this$props2.intl.formatMessage;
      var filteredSkus = _this.state.filteredSkus;
      var filtered = filteredSkus.includes(skuInfo.sku);

      var shouldExcludeSku = function shouldExcludeSku(sku) {
        return sku in excludingSkus;
      };

      return skuCardCustomRenderFn ? skuCardCustomRenderFn({
        skuInfo: skuInfo,
        disabled: disabled,
        excludingSkus: excludingSkus,
        shouldExcludeSku: shouldExcludeSku,
        filtered: filtered,
        onAddAction: onAddAction
      }) : _react.default.createElement(_SkuCard.default, {
        skuInfo: skuInfo,
        className: "sku-search__results-result",
        hasAction: true,
        disabled: disabled,
        disabledTooltipMsg: formatMessage(_skuSelectorMessages.skuCardMessages.disabledTooltip),
        actionIcon: shouldExcludeSku(skuInfo.sku) ? 'check-circle-2-f' : 'add-circle-1',
        onAction: shouldExcludeSku(skuInfo.sku) ? null : onAddAction
      });
    };

    return _this;
  }

  (0, _createClass2.default)(SkuSearch, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          filteringSkus = _this$props3.filteringSkus,
          resultsClassName = _this$props3.resultsClassName,
          bulkAddSkus = _this$props3.bulkAddSkus,
          style = _this$props3.style,
          formatMessage = _this$props3.intl.formatMessage,
          skipLoadDescriptionsForBulkAddSkus = _this$props3.skipLoadDescriptionsForBulkAddSkus,
          customBulkErrorMessage = _this$props3.customBulkErrorMessage,
          customSkuCardVirtualizedListProps = _this$props3.customSkuCardVirtualizedListProps;
      var _this$state = this.state,
          skuSearchResult = _this$state.skuSearchResult,
          query = _this$state.query,
          querying = _this$state.querying,
          totalCount = _this$state.totalCount,
          currentPage = _this$state.currentPage,
          error = _this$state.error,
          addSkusModalOpened = _this$state.addSkusModalOpened;
      var currentCount = totalCount > currentPage * PAGE_SIZE ? currentPage * PAGE_SIZE : totalCount;
      var renderPrev = currentPage > 1;
      var nextCount = totalCount - currentCount;
      var prevCount = totalCount - nextCount - PAGE_SIZE;
      var renderNext = nextCount > 0;

      var countOrPageSize = function countOrPageSize(c) {
        return c > PAGE_SIZE ? PAGE_SIZE : c;
      };

      var navsRender = _react.default.createElement("div", {
        className: "sku-search__navs"
      }, renderPrev && _react.default.createElement("button", {
        className: "prev",
        onClick: function onClick() {
          return _this2.onQuery(query, currentPage - 1);
        }
      }, _react.default.createElement("i", {
        className: "fa fa-lg fa-angle-left"
      }), " ".concat(formatMessage(_skuSelectorMessages.skuSearchMessages.previousButtonText), " ").concat(countOrPageSize(prevCount))), renderNext && _react.default.createElement("button", {
        className: "next",
        onClick: function onClick() {
          return _this2.onQuery(query, currentPage + 1);
        }
      }, "".concat(formatMessage(_skuSelectorMessages.skuSearchMessages.nextButtonText), " ").concat(countOrPageSize(nextCount), " "), _react.default.createElement("i", {
        className: "fa fa-lg fa-angle-right"
      })));

      var skuSearchResultsList = skuSearchResult ? Object.values(skuSearchResult) : [];

      var searchResultsListRender = _react.default.createElement(_SkuCardVirtualizedList.default, Object.assign({
        skuCardList: skuSearchResultsList,
        skuCardRenderer: this.skuCardRenderer
      }, customSkuCardVirtualizedListProps));

      var noSearchResult = !skuSearchResultsList || skuSearchResultsList.length === 0 || querying || filteringSkus || !query || query === '';

      var addMultipleSkusSection = _react.default.createElement("div", null, _react.default.createElement("h5", {
        style: {
          marginBottom: '15px'
        }
      }, formatMessage(_skuSelectorMessages.skuSearchMessages.addPrompt)), addSkusModalOpened && _react.default.createElement(_SkuUploadModal.default, {
        show: addSkusModalOpened,
        onClose: this.closeAddSkusModal,
        bulkAddSkus: bulkAddSkus,
        skipLoadDescriptionsForBulkAddSkus: skipLoadDescriptionsForBulkAddSkus,
        customBulkErrorMessage: customBulkErrorMessage,
        add: true
      }), _react.default.createElement(_reactComponents.Button, {
        type: "primary",
        onClick: this.openAddSkusModal,
        disabled: disabled
      }, formatMessage(_skuSelectorMessages.skuSearchMessages.addButtonText)));

      var skuSearchResultsContent;

      if (querying) {
        skuSearchResultsContent = _react.default.createElement(_reactComponents.shapes.Spinner, null);
      } else if (!query) {
        skuSearchResultsContent = addMultipleSkusSection;
      } else if (skuSearchResultsList && skuSearchResultsList.length > 0) {
        skuSearchResultsContent = searchResultsListRender;
      } else {
        var innerText;

        if (error) {
          innerText = formatMessage(_skuSelectorMessages.skuSearchMessages.detailedErrorMessage, {
            error: error
          });
        } else {
          innerText = formatMessage(_skuSelectorMessages.skuSearchMessages.notFoundErrorMessage, {
            query: query
          });
        }

        skuSearchResultsContent = _react.default.createElement("span", {
          className: "sku-search__results-text"
        }, innerText);
      }

      var searchBarRender = _react.default.createElement("form", {
        className: "sku-search__search",
        onSubmit: this.onSubmit
      }, _react.default.createElement(_CooldownTextField.default, {
        handleValueChange: this.onSearchValueChange,
        triggerChange: this.onSearch,
        name: "btnMid",
        label: formatMessage(_skuSelectorMessages.skuSearchMessages.searchBarLabel),
        value: query,
        required: true
      }));

      var totalCountRender = _react.default.createElement("div", {
        className: "sku-search__totalcount"
      }, _react.default.createElement("p", null, !noSearchResult ? _react.default.createElement("span", null, formatMessage(_skuSelectorMessages.skuSearchMessages.currentlyViewingText), _react.default.createElement("b", null, currentCount === totalCount ? currentCount - currentCount % PAGE_SIZE + 1 : currentCount - PAGE_SIZE + 1, "-", currentCount), ' ', formatMessage(_skuSelectorMessages.skuSearchMessages.skuCountText, {
        totalCount: totalCount
      })) : null));

      var searchResultsRender = _react.default.createElement("div", {
        className: "sku-search__results".concat(noSearchResult ? '--empty' : '', " ").concat(resultsClassName || '')
      }, skuSearchResultsContent);

      return _react.default.createElement("div", {
        className: "sku-search ".concat(className || ''),
        style: style
      }, searchBarRender, totalCountRender, searchResultsRender, !noSearchResult && navsRender);
    }
  }]);
  return SkuSearch;
}(_react.PureComponent);

SkuSearch.defaultProps = {
  filteringSkus: false,
  customSkuCardVirtualizedListProps: {}
};

var _default = (0, _reactIntl.injectIntl)(SkuSearch);

exports.default = _default;